import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 112664 112664"
    {...props}
  >
    <path
      d="M34725 3858h74081v74083c0 16975-13890 30865-30865 30865H3858V34725c0-16977 13890-30867 30867-30867z"
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 7716.73,
      }}
      className="stroke1"

    />
    <path
      d="M49977 40899h21789v21789c0 4994-4084 9078-9078 9078H40899V49977c0-4995 4083-9078 9078-9078z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
